import {INavLink} from './typedef';
import {USER_ROLE} from 'feedback-system/modules/user-profile/constants';

export const links: INavLink[] = [
    {
        title: 'quality_team_feedback',
        name: 'Quality Team Feedback',
        url: '/',
        exact: true,
        roles: [USER_ROLE.USER]
    },
    {
        title: 'feedback_consolidation',
        name: 'Feedback Consolidation',
        url: '/feedback-consolidation',
        roles: [USER_ROLE.MANAGER]
    },
    {
        title: 'feedback_overview',
        name: 'Feedback Overview',
        url: '/feedback-overview',
        roles: [USER_ROLE.MANAGER, USER_ROLE.TL, USER_ROLE.PM,
            USER_ROLE.BOARD, USER_ROLE.SENIOR_LEAD, USER_ROLE.ASSOCIATED_TL]
    },
    {
        title: 'employees',
        name: 'Employees',
        url: '/employees',
        roles: [USER_ROLE.USER]
    },
    {
        title: 'admin',
        name: 'Admin',
        url: '/admin',
        roles: [USER_ROLE.ADMIN]
    }
];
